import { Directive, effect, inject, input, OnDestroy, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';

@Directive({
    selector: '[companyidDisabledScroll]',
    standalone: true,
})
export class DisabledScrollDirective implements OnDestroy {
    public companyidDisabledScroll = input.required<boolean>();

    private readonly platformId = inject<string>(PLATFORM_ID);
    private readonly document = inject(DOCUMENT);

    public constructor() {
        effect(() => {
            this.setOverflowYBodyHtml(this.companyidDisabledScroll());
        });
    }

    public setOverflowYBodyHtml(hidden: boolean): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        const body = this.document.querySelector('body');
        const html = this.document.querySelector('html');
        if (!body || !html) {
            return;
        }
        body.style.overflowY = hidden ? 'hidden' : 'overlay';
        html.style.overflowY = hidden ? 'hidden' : '';
    }

    public ngOnDestroy(): void {
        this.setOverflowYBodyHtml(false);
    }
}
